interface PaginationItemProps {
  number: number
  isCurrent?: boolean
  onPageChange: (page: number) => void
}

export function PaginationItem({
  isCurrent = false,
  number,
  onPageChange,
}: PaginationItemProps) {
  if (isCurrent) {
    return (
      <button
        disabled
        aria-current="page"
        aria-label={`Página ${number}`}
        className="w-[40px] h-[40px] rounded-full bg-restructure-background-primary-inverted text-restructure-primary-inverted text-body-sm font-semibold"
      >
        {number}
      </button>
    )
  }

  return (
    <button
      aria-label={`Página ${number}`}
      className="w-[40px] h-[40px] text-restructure-primary text-body-sm font-medium"
      onClick={() => onPageChange(number)}
    >
      {number}
    </button>
  )
}
